import { render, staticRenderFns } from "./GroupChatList.vue?vue&type=template&id=59adbe27&"
import script from "./GroupChatList.vue?vue&type=script&lang=js&"
export * from "./GroupChatList.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports